// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
  SUPER_ADMIN_DASHBOARD: '/super-admin-dashboard',
  ADMIN_DASHBOARD: '/admin-dashboard'

};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  privacy: '/privacy-policy',
  terms: '/terms-and-conditions',
  about: '/about-us',
  contact: '/contact-us',
  site: '/site',
  faqs: '/faqs',
  page403: '/403',
  sharedPost: '/shared-post', 
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/hjxMnGUJCjY7pX8lQbS7kn/%5BPreview%5D-Minimal-Web.v5.4.0?type=design&node-id=0-1&mode=design&t=2fxnS70DuiTLGzND-0',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      register: `${ROOTS.AUTH}/amplify/register`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `/`,
      loginPassword: `${ROOTS.AUTH}/login/password`,
      loginNewPassword: `${ROOTS.AUTH}/login/new-password`,
      register: `${ROOTS.AUTH}/register`,
      verify: `${ROOTS.AUTH}/verify`,
      updateProfile: `${ROOTS.AUTH}/update-profile`,
      newPassword: `${ROOTS.AUTH}/new-password`,
      forgotPassword: `${ROOTS.AUTH}/forgot-password`,
      validatePin: `${ROOTS.AUTH}/validate-pin`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },

  dashboard: {
    root: ROOTS.DASHBOARD,
    file: `${ROOTS.DASHBOARD}/file`,
    totalFilesUploaded: `${ROOTS.DASHBOARD}/total-files-uploaded`,
    fileDetail: (id) => `${ROOTS.DASHBOARD}/file/${id}`,
    faqs: `${ROOTS.DASHBOARD}/faqs`,
    fileManager: `${ROOTS.DASHBOARD}/category-manager`,
    upload: `${ROOTS.DASHBOARD}/uploads`,
    projectManager: `${ROOTS.DASHBOARD}/project-manager`,
    profile: `${ROOTS.DASHBOARD}/profile`,
  },

  adminDashboard: {
    root: ROOTS.ADMIN_DASHBOARD,
    file: `${ROOTS.ADMIN_DASHBOARD}/file`,
    fileDetail: (id) => `${ROOTS.ADMIN_DASHBOARD}/file/${id}`,
    faqs: `${ROOTS.ADMIN_DASHBOARD}/faqs`,
    fileManager: `${ROOTS.ADMIN_DASHBOARD}/category-manager`,
    projectManager: `${ROOTS.ADMIN_DASHBOARD}/project-manager`,
    upload: `${ROOTS.ADMIN_DASHBOARD}/uploads`,
    terms: `${ROOTS.ADMIN_DASHBOARD}/terms`,
    privacy: `${ROOTS.ADMIN_DASHBOARD}/privacy`,
    profile: `${ROOTS.ADMIN_DASHBOARD}/profile`,
    contactSupport: `${ROOTS.ADMIN_DASHBOARD}/contact-support`,
    contactUs: `${ROOTS.ADMIN_DASHBOARD}/contact-us`,
    aboutUs: `${ROOTS.ADMIN_DASHBOARD}/about-us`,
    user: `${ROOTS.ADMIN_DASHBOARD}/users`,
    category: `${ROOTS.ADMIN_DASHBOARD}/category`,
    banner: `${ROOTS.ADMIN_DASHBOARD}/banner`,
  },
  superAdminDashboard: {
    root: ROOTS.SUPER_ADMIN_DASHBOARD,
    file: `${ROOTS.SUPER_ADMIN_DASHBOARD}/file`,
    fileDetail: (id) => `${ROOTS.SUPER_ADMIN_DASHBOARD}/file/${id}`,
    faqs: `${ROOTS.SUPER_ADMIN_DASHBOARD}/faqs`,
    fileManager: `${ROOTS.SUPER_ADMIN_DASHBOARD}/category-manager`,
    projectManager: `${ROOTS.SUPER_ADMIN_DASHBOARD}/project-manager`,
    upload: `${ROOTS.SUPER_ADMIN_DASHBOARD}/uploads`,
    terms: `${ROOTS.SUPER_ADMIN_DASHBOARD}/terms`,
    privacy: `${ROOTS.SUPER_ADMIN_DASHBOARD}/privacy`,
    profile: `${ROOTS.SUPER_ADMIN_DASHBOARD}/profile`,
    contactSupport: `${ROOTS.SUPER_ADMIN_DASHBOARD}/contact-support`,
    contactUs: `${ROOTS.SUPER_ADMIN_DASHBOARD}/contact-us`,
    aboutUs: `${ROOTS.SUPER_ADMIN_DASHBOARD}/about-us`,
    user: `${ROOTS.SUPER_ADMIN_DASHBOARD}/users`,
    category: `${ROOTS.SUPER_ADMIN_DASHBOARD}/category`,
    banner: `${ROOTS.SUPER_ADMIN_DASHBOARD}/banner`,
  }
};
